import React from "react";
import Link from "@mui/material/Link";

export default function useAlertsNotifications() {

  const alertsTypes = {
    AlertMcLeod: <>
    The system is having trouble accessing McLeod at this time, please try again and if the problem persists submit a new&nbsp;
      <Link 
        href='https://capstonelogistics.service-now.com/sp'
        target="_blank" rel="noopener"
        underline="none"
        sx={{ color: "primary.60", fontWeight: 800 }}
      >
        Service Now
      </Link>
    &nbsp;ticket.
    </>,
    AlertDocumentPower: <>
    Your account does not have access to Document Power. Please request access from IT through a&nbsp;
      <Link 
        href='https://capstonelogistics.service-now.com/sp'
        target="_blank" rel="noopener"
        underline="none"
        sx={{ color: "primary.60", fontWeight: 800 }}
      >
        Service Now
      </Link>
    &nbsp;ticket.
    </>,
    CarrierNoAvailable: <>
    Carrier no longer available to add as a lead
    </>
  };

  return { alertsTypes };
}